export default __webpack_public_path__ + "static/media/sensor_default.38789fa9.svg";